import * as React from 'react';
import * as PropTypes from 'prop-types';
import version from '../../version';
import { AppContext } from './../../context/AppContext';

export const Header = (props) => {
  const { onButtonClick, page } = props;
  const { avatar, name } = React.useContext(AppContext);

  const imgRef = React.useRef(null);
  const hasImage = avatar && avatar.length > 0;

  React.useEffect(() => {
    if (hasImage) {
      var reader = new FileReader();

      reader.onload = function (e) {
        imgRef.current.setAttribute('src', e.target.result);
      };

      reader.readAsDataURL(avatar[0].getRawFile());
    }
  }, [avatar, hasImage]);

  return (
    <header className="header">
      <div className="nav-container">
        <div className="menu-button">
          <span className={'k-icon hamburger-icon'} onClick={onButtonClick} />
        </div>
        <div className="title">
          <div style={{ display: 'flex' }}>
            <h2>{page === 'Dashboard' ? 'Slot Message Management' : page}</h2>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ marginRight: '2em', marginTop: '3px' }}>
            Airport: <b>{window.env.AIRPORT_CODE}</b>
          </span>
          <span style={{ marginRight: '2em', marginTop: '3px' }}>
            Timezone: <b>{window.env.AIRPORT_TZ}</b>
          </span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ marginRight: '2em', marginTop: '3px' }}>
            Environment: <b>{window.env.ENVIRONMENT}</b>
          </span>
          <span style={{ marginRight: '2em', marginTop: '3px' }}>
            Version: <b>{version}</b>
          </span>
        </div>
        <span className={'k-icon k-i-user'} onClick={onButtonClick} />
        <h3 style={{ marginRight: '1em' }}>{name}</h3>
      </div>
    </header>
  );
};

Header.displayName = 'Header';
Header.propTypes = {
  page: PropTypes.string,
  onButtonClick: PropTypes.func,
};
